import React from 'react';
import styled from 'styled-components';
import davidoff from '../../../../themes/davidoff';

export default styled.div`
  border-top: 1px solid ${davidoff.colors.lightbrown};
  padding: 20px 0;
`;
